import gql from 'graphql-tag'

import { stringifyAttributes } from 'utils/index'

import configureApolloClient from 'network/index'

const apolloClient = configureApolloClient()

export const CREATE_EDITOR_STATE = 'CREATE_EDITOR_STATE'
export const DESTROY_EDITOR_STATE = 'DESTROY_EDITOR_STATE'

export const ADD_COMPONENT_TO_PAGE = 'ADD_COMPONENT_TO_PAGE'
export const REMOVE_COMPONENT_FROM_PAGE = 'REMOVE_COMPONENT_FROM_PAGE'
export const MOVE_PAGE_COMPONENT = 'MOVE_PAGE_COMPONENT'

export const OPEN_BROWSER = 'OPEN_BROWSER'
export const CLOSE_BROWSER = 'CLOSE_BROWSER'

export const SELECT_PAGE_COMPONENT = 'SELECT_PAGE_COMPONENT'
export const UNSELECT_PAGE_COMPONENT = 'UNSELECT_PAGE_COMPONENT'

export const UPDATE_PAGE_COMPONENT_ATTRIBUTE = 'UPDATE_PAGE_COMPONENT_ATTRIBUTE'

export const SAVE_PAGE_CHANGES_REQUEST = 'SAVE_PAGE_CHANGES_REQUEST'
export const SAVE_PAGE_CHANGES_DATA_MERGE = 'SAVE_PAGE_CHANGES_DATA_MERGE'
export const SAVE_PAGE_CHANGES_SUCCESS = 'SAVE_PAGE_CHANGES_SUCCESS'
export const SAVE_PAGE_CHANGES_COMPLETE = 'SAVE_PAGE_CHANGES_COMPLETE'

export const createEditorState = () => ({
  type: CREATE_EDITOR_STATE
})

export const destroyEditorState = () => ({
  type: DESTROY_EDITOR_STATE
})

export const addComponentToPage = component => ({
  type: ADD_COMPONENT_TO_PAGE,
  component
})

export const removeComponentFromPage = pageComponentClientId => ({
  type: REMOVE_COMPONENT_FROM_PAGE,
  pageComponentClientId
})

export const movePageComponent = (pageComponentClientId, position) => ({
  type: MOVE_PAGE_COMPONENT,
  pageComponentClientId,
  position
})

export const openBrowser = insertAtIndex => ({
  type: OPEN_BROWSER,
  insertAtIndex
})

export const closeBrowser = () => ({
  type: CLOSE_BROWSER
})

export const selectPageComponent = pageComponent => ({
  type: SELECT_PAGE_COMPONENT,
  pageComponent
})

export const unselectPageComponent = () => ({
  type: UNSELECT_PAGE_COMPONENT
})

export const updatePageComponentAttribute = attribute => ({
  type: UPDATE_PAGE_COMPONENT_ATTRIBUTE,
  attribute
})

export const savePageChanges = (options = { silent: false }) => async (dispatch, getState) => {
  try {
    const { page, pageComponents } = getState().project

    if (!options.silent) {
      dispatch({
        type: SAVE_PAGE_CHANGES_REQUEST
      })
    }

    const response = await apolloClient.mutate({
      variables: {
        pageId: page._id,
        pageComponents: pageComponents.map(pageComponent => ({
          _id: pageComponent._id,
          componentId: pageComponent.component._id,
          attributes: stringifyAttributes(pageComponent.attributes)
        }))
      },
      mutation: gql`
        mutation updatePage($pageId: ID!, $pageComponents: [PageComponentInput]!) {
          updatePage(pageId: $pageId, pageComponents: $pageComponents) {
            _id
            name
    
            components {
              _id
              
              component {
                _id
                type
                name
              }
    
              attributes {
                _id
                key
                type
                value
              }
            }
          }
        }
      `
    })

    dispatch({
      type: SAVE_PAGE_CHANGES_DATA_MERGE,
      page: response.data.updatePage
    })

    if (!options.silent) {
      dispatch({
        type: SAVE_PAGE_CHANGES_SUCCESS
      })

      setTimeout(() => {
        dispatch({
          type: SAVE_PAGE_CHANGES_COMPLETE
        })
      }, 800)
    }
  } catch (error) {
    // todo: invoke notification
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/editor.js